module.exports = __webpack_public_path__ + "img/bg2.157752fd.png";